/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useMemo } from 'react';
import { Button, Tooltip } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import { useDispatch, useSelector } from 'react-redux';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { useObjectContext } from '@/hooks/useObjectContext';
import { openDialog } from '@/features/dialog/dialogSlice';
import { useFeatureFlagContext } from '@/context/featureFlagContext';

export const PreRenewalEmailButton = () => {
	const dispatch = useDispatch();

	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;
	const userQuery = useGetUserDetailsQuery({ email }, { skip: !email });

	const { dealRow, clientRow, dealId } = useObjectContext();

	const disabled = useMemo(() => dealRow?.renewalDate == null, [dealRow?.renewalDate]);

	const { getFeatureFlags } = useFeatureFlagContext();
	const showUnlayerEmails = Boolean(getFeatureFlags('unlayerEmails')?.active);

	return (
		<>
			<Tooltip title={disabled ? 'Please enter a renewal date' : null}>
				<div>
					<Button
						disabled={disabled || !dealRow || !userQuery.data}
						variant='tab_header'
						startIcon={<EmailIcon />}
						onClick={() => {
							if (showUnlayerEmails) {
								dispatch(
									openDialog({
										dialogName: 'unlayerEmail',
										data: {
											clientLocked: true,
											dealLocked: true,
											client: clientRow ?? null,
											deal: dealRow ?? null,
										},
									}),
								);
							} else {
								dispatch(
									openDialog({
										dialogName: 'email',
										data: { template: 'preRenewal' },
									}),
								);
							}
						}}
					>
						{'Email Pre-Renewal'}
					</Button>
				</div>
			</Tooltip>
		</>
	);
};
